module.exports = __webpack_public_path__ + "img/after1.065437ba.jpg";